import { Flex, Typography } from 'antd'
import { createStyles } from 'antd-style'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'

import { BrandWordmark, BRAND_NAME, Container } from 'src/components'
import { useDocumentTitle } from 'src/hooks'
import { paths } from 'src/router'

const { Title, Paragraph, Text, Link } = Typography

const useStyles = createStyles(() => ({
  page: {
    width: '100%',
    maxWidth: 760,
    marginInline: 'auto',
    paddingBlock: 40
  },
  brandLink: {
    display: 'inline-block',
    maxWidth: 150,
    lineHeight: 0
  }
}))

export const TermsAndConditions = () => {
  const { t } = useTranslation()
  const { styles } = useStyles()

  useDocumentTitle(t('terms_title'))

  const sections = [
    {
      title: t('terms_section_acceptance_title'),
      body: t('terms_section_acceptance_body')
    },
    {
      title: t('terms_section_account_title'),
      body: t('terms_section_account_body')
    },
    {
      title: t('terms_section_use_title'),
      body: t('terms_section_use_body')
    },
    {
      title: t('terms_section_privacy_title'),
      body: t('terms_section_privacy_body')
    },
    {
      title: t('terms_section_availability_title'),
      body: t('terms_section_availability_body')
    },
    {
      title: t('terms_section_changes_title'),
      body: t('terms_section_changes_body')
    }
  ]

  return (
    <Container>
      <Flex orientation="vertical" gap={24} className={styles.page}>
        <RouterLink
          to={paths.home}
          aria-label={`${BRAND_NAME} home`}
          className={styles.brandLink}
        >
          <BrandWordmark variant="auth" />
        </RouterLink>

        <Title level={1} style={{ marginBottom: 0 }}>
          {t('terms_title')}
        </Title>
        <Text type="secondary">{t('terms_updated')}</Text>
        <Paragraph>{t('terms_intro')}</Paragraph>

        <Flex
          component="ol"
          orientation="vertical"
          gap={16}
          style={{ paddingLeft: 0, margin: 0, listStyle: 'none' }}
        >
          {sections.map((item) => (
            <Flex
              key={item.title}
              component="li"
              orientation="vertical"
              gap={4}
            >
              <Text strong>{item.title}</Text>
              <Text>{item.body}</Text>
            </Flex>
          ))}
        </Flex>

        <Paragraph>
          {t('terms_contact')}{' '}
          <Link
            href="mailto:support@skalx.ai"
            target="_blank"
            rel="noopener noreferrer"
          >
            support@skalx.ai
          </Link>
          .
        </Paragraph>

        <RouterLink to={paths.auth.login}>
          {t('auth.emailOtp.backToSignIn')}
        </RouterLink>
      </Flex>
    </Container>
  )
}
